import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Subscription } from 'rxjs';

import { SnackbarService } from "../../../../shared/services/snackbar.service";
import { SessionStorageService } from "../../../../shared/services/session-storage.service";
import { FollowUpEmailService } from './follow-up-email.service';

@Component({
	selector: 'follow-up-email',
	styles: [require('./follow-up-email.component.less')],
	template: require('./follow-up-email.component.html'),
	providers: [FollowUpEmailService, SnackbarService],
	preserveWhitespaces: true
})

export class FollowUpEmail {
	editorContent: any;
	emailDetails: any;
	loading: boolean = false;
	public options: Object = {
		key: 'MA-16E-13oldxqvwtbvhlvoA5B-21qr==',
		charCounterCount: false,
		toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'align', '|', 'undo', 'redo'],
		toolbarButtonsXS: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'align', '|', 'undo', 'redo'],
		toolbarButtonsSM: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'align', '|', 'undo', 'redo'],
		toolbarButtonsMD: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'align', '|', 'undo', 'redo'],
		imageUpload: false, // Disable image upload
		imagePaste: false, // Disable pasting images
	};

	apiSubscriptions: Subscription[] = [];

	constructor(
		public dialogRef: MatDialogRef<any>,
		private _sessionStorageService: SessionStorageService,
		private _mdlSnackbarService: SnackbarService,
		private _followUpEmailService: FollowUpEmailService
	) { }

	getTemplate(data: any) {
		if (data.section !== 'follow-up'
			|| data.plan_status === 'not_started'
			|| !data.plan_status) {
			this.loading = true;
			this.apiSubscriptions.push(
				this._followUpEmailService.getFollowupEmailTemplate(data.section, data)
					.subscribe((res: any) => this.getTemplateSuccessHandler(res),
						error => this.getTemplateErrorHandler(error))
			);
		}
	}

	getTemplateSuccessHandler(res: any) {
		this.loading = false;
		this.editorContent = res;
	}

	getTemplateErrorHandler(error: any) {
		this.loading = false;
		this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
	}

	sendEmailContent() {
		// Remove empty <p> tags at the beginning and end only
		let content = this.editorContent;
		if (content) {
			// Remove empty <p> tags at the start (matches <p></p>, <p>&nbsp;</p>, <p><br></p>, <p> </p>, etc.)
			content = content.replace(/^(<p[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/p>\s*)+/gi, '');
			// Remove empty <p> tags at the end
			content = content.replace(/(\s*<p[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/p>)+$/gi, '');
		}
		this.dialogRef.close(content);
	}

	ngOnInit() {
		this._sessionStorageService.readItem('emailDetails').then((data) =>
			this.getTemplate(data)
		);
	}

	ngOnDestroy() {
		this.apiSubscriptions.forEach((subscription) => {
			subscription?.unsubscribe();
		});
	}
}